import { UntypedFormControl } from "@angular/forms";
import { timer, of } from "rxjs";
import { switchMap, map, catchError } from "rxjs/operators";
import { VerifyPhoneNumberService } from '../services/verify-phone-number/verify-phone-number.service';

export const checkPhoneNumberExistsAsync = (
  verifyPhoneService: VerifyPhoneNumberService,
  debounce: number = 300
) => {
  return (input: UntypedFormControl) => {
    return timer(debounce).pipe(
      switchMap(() => {
        return verifyPhoneService.checkPhoneNumberExists(input.value).pipe(
          map((res: {is_present: boolean}) => {
            return res.is_present ? { phoneNumberExists: true } : null;
          }),
          catchError(err => {
            return of({ numberCheckFailed: true });
          })
        );
      })
    );
  };
};
